class ExchangeForm {
  constructor(notice) {
    this.notice = notice;
    this.init();
  }

  init() {
    if (this.notice && !document.getElementsByClassName('jsExchangeBanner warning').length) {
      this.addWarningNotice();
    }

    TeePublic.Utility.preventDoubleSubmit('#exchange-form');

    const exchangeItemForms = document.getElementsByClassName('jsExchangeItemForm');
    for (let i = 0; i < exchangeItemForms.length; i++) {
      const exchangeItemForm = exchangeItemForms[i];
      this.toggleFormInputs(exchangeItemForm, true);
      this.toggleFormDisplayOnCheckboxChange(exchangeItemForm);
      this.changeInputsOnExchangeReasonChange(exchangeItemForm);
    }
  }

  addWarningNotice() {
    const newWarningPillSection = document.createElement('section');
    const newWarningPill = document.createElement('div');
    newWarningPill.classList.add('jsExchangeBanner', 'p-exchanges__banner', 'warning');
    newWarningPill.innerHTML = this.notice;
    newWarningPillSection.appendChild(newWarningPill);
    const apparelPillSection = document.querySelector('.jsExchangeBanner').parentNode;
    apparelPillSection
      .parentNode
      .insertBefore(newWarningPillSection, apparelPillSection.nextSibling);
  }

  toggleFormInputs(exchangeItemForm, disabled=false) {
    const itemInputs =
      exchangeItemForm
        .querySelector('.jsExchangeItemFormInputs')
        .querySelectorAll('input,textarea,select');
    for (let input of itemInputs) {
      if (!input.parentNode.classList.contains('hidden')) input.disabled = disabled;
    };
  }

  toggleFormDisplayOnCheckboxChange(exchangeItemForm) {
    const checkbox = exchangeItemForm.querySelector('.jsExchangeCheckboxes');
    if (checkbox) {
      checkbox.addEventListener('change', (e) => {
        if (e.target.checked) {
          this.toggleFormInputs(exchangeItemForm);
          this.hideSingleExchangeProductOptionDropdowns(exchangeItemForm);
          exchangeItemForm.classList.add('selected');
        } else {
          this.toggleFormInputs(exchangeItemForm, true);
          this.hideExchangeProductOptionDropdowns(exchangeItemForm);
          exchangeItemForm.classList.remove('selected');
        }
      });
    }
  }

  changeInputsOnExchangeReasonChange(exchangeItemForm) {
    const exchangeReasonSelectBox = exchangeItemForm.querySelector('.jsExchangeCrmTags');
    if (exchangeReasonSelectBox) {
      exchangeReasonSelectBox.addEventListener('change', (e) => {
        this.toggleNoteField(e, exchangeItemForm);
        this.toggleSizeField(e, exchangeItemForm);
      });
    }
  }

  toggleNoteField(e, exchangeItemForm) {
    const noteField = exchangeItemForm.querySelector('.jsExchangeNote');
    if (e.target.value === 'other') {
      noteField.disabled = false;
      noteField.parentNode.classList.remove('hidden');
      this.hideExchangeProductOptionDropdowns(exchangeItemForm);
    } else {
      noteField.disabled = true;
      noteField.parentNode.classList.add('hidden');
      this.hideSingleExchangeProductOptionDropdowns(exchangeItemForm);
    }
  }

  toggleSizeField(e, exchangeItemForm) {
    let oliId = e
      .target
      .parentNode
      .parentNode
      .parentNode
      .querySelector('.jsExchangeProductId')
      .getAttribute('data-oli-id');
    const sizeField = exchangeItemForm.querySelector(`.jsSelect_${oliId}.size`);
    if (['too_small', 'too_large'].includes(e.target.value)) {
      sizeField.disabled = false;
      sizeField.parentNode.parentNode.classList.remove('hidden');
    } else {
      sizeField.disabled = true;
      sizeField.parentNode.parentNode.classList.add('hidden');
      this.hideSingleExchangeProductOptionDropdowns(exchangeItemForm);
    }
  }

  hideSingleExchangeProductOptionDropdowns(exchangeItemForm) {
    const exchangeReasonSelectBox = exchangeItemForm.querySelector('.jsExchangeCrmTags');
    if (exchangeReasonSelectBox && exchangeReasonSelectBox.value == 'other')  return this.hideExchangeProductOptionDropdowns;

    const exchangeProductOptions =
      exchangeItemForm
        .getElementsByClassName('jsExchangeProductOptions')[0]
        .getElementsByClassName('option');
    for (let exchangeProductOption of exchangeProductOptions) {
      const productOptionDropdown = exchangeProductOption.getElementsByClassName('select')[0];
      if (productOptionDropdown.options.length == 1) {
        exchangeProductOption.classList.add('hidden');
      } else {
        exchangeProductOption.classList.remove('hidden');
      }
    };
  }

  hideExchangeProductOptionDropdowns(exchangeItemForm) {
    const exchangeProductOptions =
      exchangeItemForm
        .getElementsByClassName('jsExchangeProductOptions')[0]
        .getElementsByClassName('option')
    for (let exchangeProductOption of exchangeProductOptions) exchangeProductOption.classList.add('hidden');
  }
}

export default ExchangeForm;
